<template>
  <div class="form__flex form__flex-start">
    <div class="form__left">
      <VInput
        id="name"
        v-model="formData.name"
        name="name"
        :max-length="150"
        :errors="v$.name.$errors"
        :server-errors="serverErrors.value?.name"
        :disabled="isBidder"
        :class-input="['input input-long input-placeholder-black input-border-bottom']"
        placeholder="Название лота"
        @blur="validateField"
        @input="validateField" />

      <VSelect
        id="company_id"
        v-model="formData.company_id"
        name="company_id"
        :options="company"
        :errors="v$.company_id.$errors"
        :server-errors="serverErrors.value?.company_id"
        :disabled="isBidder"
        classes="select-border-bottom"
        class="input-long"
        placeholder="Компания"
        @blur="validateField"
        @input="validateField" />

      <VTextarea
        id="note"
        v-model="formData.note"
        name="note"
        :server-errors="serverErrors.value?.note"
        :disabled="isBidder"
        label="Примечание организатора"
        text-area-class="textarea-bg-transparent textarea-border-gray textarea-height-150 textarea-n-resize mb-40" />

      <VInput
        id="order_number"
        v-model="formData.order_number"
        name="order_number"
        :disabled="isBidder"
        :class-input="['input input-long input-placeholder-black input-border-bottom']"
        placeholder="№ заказа поставщика" />

      <VInput
        id="responsible_full_name"
        v-model="formData.responsible_full_name"
        name="responsible_full_name"
        :errors="v$.responsible_full_name.$errors"
        :server-errors="serverErrors.value?.responsible_full_name"
        :class-input="['input input-long input-placeholder-black input-border-bottom']"
        placeholder="ФИО ответственного"
        disabled
        @blur="validateField"
        @input="validateField" />

      <transition name="slide-fade">
        <VDatePicker
          v-if="!formData.isPublishedBeforeSave && !isBidder"
          id="published_at"
          v-model="formData.published_at"
          name="published_at"
          :errors="v$.published_at.$errors"
          :server-errors="serverErrors.value?.published_at"
          class-form="mb-20"
          placeholder="Дата публикации лота"
          @blur="validateField"
          @input="validateField" />
      </transition>
    </div>
    <div class="form__right">
      <VPhone
        id="responsible_phone"
        v-model="formData.responsible_phone"
        type="phone"
        name="responsible_phone"
        placeholder="Номер телефона"
        mask-type
        :errors="v$.responsible_phone.$errors"
        :server-errors="serverErrors.value?.responsible_phone"
        :disabled="isBidder"
        :class-input="['input input-long input-placeholder-black']"
        @blur="validateField"
        @input="validateField" />

      <VInput
        id="phone_extension"
        v-model="formData.phone_extension"
        name="phone_extension"
        :errors="v$.phone_extension.$errors"
        :server-errors="serverErrors.value?.phone_extension"
        :disabled="isBidder"
        :class-input="['input input-long input-placeholder-black input-border-bottom']"
        placeholder="Добавочный номер"
        @blur="validateField"
        @input="validateField" />

      <VCheckbox
        v-if="!isBidder"
        id="analog_acceptable"
        v-model="formData.analog_acceptable"
        name="analog_acceptable"
        :is-switch="true"
        :checked="formData.analog_acceptable"
        class-label="bg-white"
        :errors="v$.analog_acceptable.$errors"
        :disabled="isBidder"
        :server-errors="serverErrors.value?.analog_acceptable">
        <template #default="slotProps">
          <label :for="slotProps.for" :class="slotProps.class"> Допустимость аналогов </label>
        </template>
      </VCheckbox>

      <RadioList
        v-model="formData.divisibility"
        name="divisibility"
        :elements="divisibility"
        :server-errors="serverErrors.value?.divisibility"
        :disabled="isBidder"
        :is-center="false"
        :mod="false"
        class-form="mt-40 mb-20"
        class-radio="bg-white"
        @blur="validateField"
        @input="validateField" />
    </div>

    <VCheckbox
      v-if="!isBidder"
      id="isPublishedBeforeSave"
      v-model="formData.isPublishedBeforeSave"
      name="isPublishedBeforeSave"
      class-form="form-checkbox"
      :is-switch="true"
      :value="formData.isPublishedBeforeSave"
      class-label="bg-white"
      :server-errors="serverErrors.value?.isPublishedBeforeSave">
      <template #default="slotProps">
        <label :for="slotProps.for" :class="slotProps.class">
          Опубликовать лот сразу после сохранения
        </label>
      </template>
    </VCheckbox>
  </div>
</template>

<script setup>
import { defineExpose, defineProps, inject, onMounted, reactive } from 'vue'

import VSelect from '@/components/ui/form/VSelect'
import VTextarea from '@/components/ui/form/VTextarea'
import VCheckbox from '@/components/ui/form/Checkbox/VCheckbox'
import RadioList from '@/components/ui/form/Radio/RadioList'
import VInput from '@/components/ui/form/VInput'
import VDatePicker from '@/components/ui/form/VDatePicker'
import VPhone from '@/components/ui/form/VMask'

import { divisibility } from '@/utils/lot/list'
import { COMPANY } from '@/utils/manual/manualList'
import { manualMemoization } from '@/utils/memoization/manualMemoization'

const formData = inject('formData')
const v$ = inject('v$')
const serverErrors = inject('serverErrors')
const validateField = inject('validateField')
const company = reactive([])
defineProps({
  isBidder: {
    type: Boolean,
    required: false,
  },
})

onMounted(async () => {
  company.push(...(await manualMemoization(true, COMPANY)))
})

defineExpose({
  divisibility,
  formData,
  v$,
  validateField,
  serverErrors,
})
</script>
